// extracted by mini-css-extract-plugin
export var blue = "ModuleWrapper-module--blue--a3ffd";
export var center = "ModuleWrapper-module--center--dd1d3";
export var dark = "ModuleWrapper-module--dark--55549";
export var darkBlue = "ModuleWrapper-module--darkBlue--ff3af";
export var darkToBrightBlue = "ModuleWrapper-module--darkToBrightBlue--eb4b1";
export var headline = "ModuleWrapper-module--headline--2d796";
export var large = "ModuleWrapper-module--large--a7a40";
export var left = "ModuleWrapper-module--left--7d9bb";
export var lightGray = "ModuleWrapper-module--lightGray--ff09d";
export var normal = "ModuleWrapper-module--normal--cd34c";
export var offWhite = "ModuleWrapper-module--offWhite--f9cd1";
export var right = "ModuleWrapper-module--right--9185d";
export var seaGreen = "ModuleWrapper-module--seaGreen--56554";
export var small = "ModuleWrapper-module--small--93dd0";
export var white = "ModuleWrapper-module--white--4315a";